<template>
  <div>
    <TopNavbar />

    <header
      class="bg-primary text-white text-center py-5 practica-header min-vh-100"
    >
      <h2 class="h4">Práctica</h2>
      <img
        id="prac_img"
        class="mt-3"
        style="border: solid 2px #fff; border-radius: 7px"
        src="../assets/images/icons/trigonometry.svg"
        alt="Trigonometría"
      />
      <h1 id="prac_title" class="h3 mt-3">{{ topic }}</h1>
      <h2 id="section_title" class="h1 my-4">Resultados</h2>
      <div class="card text-dark container p-5 rounded mt-3">
        <h3>Tu puntaje es de</h3>
        <h2 id="score">{{ correct }}/{{ total }}</h2>
        <div v-if="total === correct">
          <img src="../assets/images/icons/star.svg" class="mt-2" alt="" />
          <p class="mt-2">¡Felicidades haz conseguido un puntaje completo!</p>
        </div>
        <div class="text-center">
          <a class="btn btn-primary mt-2" @click="goToDashboard">
            Elegir otro módulo
          </a> <br>
          <a class="btn btn-primary mt-2 ml-2" @click="goToReview">
            Revisón
          </a>
        </div>
      </div>
    </header>
  </div>
</template>

<script>
import TopNavbar from "@/components/TopNavbar.vue";

export default {
  name: "ExerciseResult",
  components: {
    TopNavbar,
  },
  props: ["topic", "total", "correct"],
  mounted() {
    this.$store.dispatch("dashboardCache/incrementExercisesCompleted");
  },
  methods: {
    goToDashboard() {
      this.$router.push(`/dashboard`);
    },
    goToReview() {
      this.$router.push(`/exercise/${this.topic}/review`);
    },
  },
};
</script>

<style src="@/assets/css/app.css"></style>
